import React, { Suspense } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import GlobalStyle from '../../global.styles';
import { BreadBox, Paragraph, Title, SubTitle, ListMember } from './PrivacyPolicy.style';
import Header from '../../components/Header/Header';
import DesktopFooter from '../../components/shared/DesktopFooter/DesktopFooterLandingPageG';
import MobileFooter from '../../components/shared/MobileFooter/MobileFooterLandingPage';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';

import { useTranslation } from 'react-i18next';

import Loader from '../../components/shared/Loader/Loader'

const BizdocsConst = () => {
    const { t } = useTranslation();
    const breadCrumbLinks = [
        {
            text: t('home_title'),
            href: '/',
            key: '1'
        }
    ];
    return (
        <>
            <GlobalStyle />
            <Header bgColor="#6CB93D" />

            <div className="container h-100" style={{ color: "#585858"}}>
                <Title margin="20px 0">Política de Privacidade</Title>
                <p style={{ color: "#585858" }} >
                    Nos termos da legislação aplicável relativa ao processamento de dados
                    pessoais, nomeadamente o Regulamento (UE) 2016/679 do Parlamento Europeu e do Conselho de 27 de Abril de 2016
                    (RGPD), informamos:
                </p>
                <br />
                <SubTitle margin="20px 0">Serviço – Bizdocs</SubTitle>
                <p style={{ color: "#585858" }} >
                    Prestador do Serviço – Latourrette Consulting – Consultoria de Inovação
                    em Gestão da Informação, LDA, sociedade por quotas com sede na Rua do Outeiro, nº2, 1.º Frente – Sala 5,
                    4050-452 Porto, matriculada na Conservatória do registo comercial do Porto com o número único de matrícula e
                    pessoa colectiva 509358772. UTILIZADOR – Pessoa singular e colectiva que adquire/utilize o Serviço
                </p>
                <br />
                <SubTitle margin="20px 0">Quanto aos dados do utilizador:</SubTitle>
                <p style={{ color: "#585858" }} >
                    A Latourrette Consulting, enquanto criadora e prestadora do SERVIÇO,
                    garante que os dados pessoais do UTILIZADOR são recolhidos com a finalidade de serem incluídos na base de dados
                    de clientes da Latourrette Consulting para efeitos de gestão comercial do cliente, facturação, comercialização
                    de produtos e serviços, contacto com o cliente, promoção, publicidade e para efeitos estatísticos.
                </p>
                <p style={{ color: "#585858" }} >
                    Quando o UTILIZADOR adere ao SERVIÇO, aceita e reconhece que terá de
                    fornecer os seus dados pessoais estritamente necessários para a prestação do mesmo; tais dados serão utilizados
                    exclusivamente para os supra referidos efeitos.
                </p>
                <p style={{ color: "#585858" }} >
                    Em caso algum os dados pessoais do UTILIZADOR serão divulgados,
                    fornecidos a terceiros, sem o consentimento expresso do UTILIZADOR, excepto se nos casos previstos no ponto
                    seguinte.
                </p>
                <p style={{ color: "#585858" }} >
                    A Latourrette Consulting fornecerá os dados da conta do UTILIZADOR às
                    autoridades competentes caso tal seja obrigatório por Lei ou a Latourrette Consulting seja notificada ou
                    intimada judicialmente para esse efeito. A Latourrette Consulting poderá igualmente comunicar os seus dados a
                    terceiros, em caso de incumprimento dos termos e condições de utilização do SERVIÇO, em sede de exercício dos
                    direitos da Latourrette Consulting em sede de responsabilidade civil, contra-ordenacional ou criminal.
                </p>
                <p style={{ color: "#585858" }} >
                    Em qualquer momento, o utilizador poderá exercer os seus direitos de
                    acesso, rectificação, eliminação, limitação e/ ou portabilidade através de comunicação escrita, acompanhada de
                    documento que comprove a sua identidade e/ou os dados a rectificar, se aplicável, que deve ser enviada para o
                    endereço de e-mail: support@bizdocs.mobi.
                </p>
                <p style={{ color: "#585858" }} >
                    A oposição ao tratamento de dados aqui referido, que seja comunicado à
                    Latourrette Consulting após o início do mesmo terá efeitos apenas a partir da data de recepção de tal
                    comunicação, não afectando a legitimidade do tratamento até aí efectuado. Tal oposição poderá significar a
                    impossibilidade de prestação do SERVIÇO.
                </p>
                <p style={{ color: "#585858" }} >
                    No que respeita ao exercício do direito à portabilidade dos dados, por
                    favor tenha em consideração que, nos termos da legislação aplicável, o mesmo só é aplicável em relação aos dados
                    recolhidos com base no seu consentimento.
                </p>
                <br />
                <SubTitle margin="20px 0">Quanto aos dados que o utilizador coloca no Bizdocs:</SubTitle>
                <p style={{ color: "#585858" }} >
                    O UTILIZADOR, enquanto responsável pelo tratamento dos dados que coloca
                    no software para a utilização do SERVIÇO, declara expressamente e garante que:
                </p>
                <ol class="list-ol-lower-alpha" type="a">
                    <li style={{ color: "#585858" }} class="pb-4 pl-4">
                        Se encontram verificadas as condições de legitimidade previstas na
                        lei para a realização do tratamento de dados da sua responsabilidade.
                    </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Irá transmitir à Latourrette Consulting as instruções necessárias ao
                        tratamento de dados pretendido.
                    </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Apenas comunicará à Latourrette Consulting os dados pessoais
                        estritamente necessários para a execução dos serviços contratados com a Latourrette Consulting.
                    </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Adopta as medidas técnicas e organizativas necessárias para
                        assegurar a actualização e a veracidade dos dados comunicados à Latourrette Consulting.
                    </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Adopta as medidas técnicas e organizativas adequadas a garantir a
                        confidencialidade e segurança dos dados pessoais comunicados à Latourrette Consulting, de forma a prevenir e
                        evitar a sua destruição, acidental ou ilícita, alteração, perda acidental, difusão ou acesso não
                        autorizados, nomeadamente quando os mesmos forem transmitidos por rede, e contra qualquer forma de
                        tratamento ilícito, em conformidade com as categorias de dados tratados.
                    </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Tem implementados os procedimentos adequados à satisfação dos
                        direitos dos titulares dos dados.
                    </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Tem implementados os procedimentos adequados ao cumprimento das
                        obrigações de notificação à autoridade de controlo e aos titulares dos dados, caso se verifique uma violação
                        de dados.
                    </li>
                </ol>
                <br />
                <p style={{ color: "#585858" }} >
                    A Latourrette Consulting enquanto prestadora do SERVIÇO e subcontratante
                    no tratamento de dados pessoais, garante ao UTILIZADOR que:
                </p>
                <ol class="list-ol-lower-alpha" type="a">
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Procederá ao tratamento dos dados que lhe sejam comunicados pelo
                        UTILIZADOR apenas de acordo com as instruções transmitidas pelo UTILIZADOR, de acordo com as finalidades
                        para as quais os dados foram recolhidos, e apenas para assegurar o cumprimento das obrigações assumidas para
                        a prestação do SERVIÇO e a execução das operações para tal previstas;
                    </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Adoptará as medidas técnicas e organizativas necessárias e adequadas
                        que garantam a confidencialidade e a segurança dos dados e evitem a sua destruição, acidental ou ilícita,
                        alteração, perda acidental, difusão ou acesso não autorizados, nomeadamente quando o tratamento implicar a
                        sua transmissão por rede, e contra qualquer forma de tratamento ilícito;
                   </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Manterá um registo dos tratamentos de dados executados por conta do
                        UTILIZADOR, o qual deve conter, pelo menos, o nome e os contactos do UTILIZADOR, de outros subcontratados e,
                        se aplicável, do encarregado da protecção de dados e uma descrição dos tratamentos de dados executados;
                    </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Limitará o acesso pelos seus colaboradores aos dados pessoais
                        comunicados pelo UTILIZADOR, sendo concedido apenas na medida em que tal se revele necessário ao desempenho
                        das respectivas funções que lhes sejam cometidas no âmbito da prestação dos serviços;
                    </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Assegurará que os colaboradores a quem seja dado acesso aos dados
                        pessoais se vinculam a obrigações de confidencialidade em relação a tais dados e que se abstenham de os
                        utilizar para fins diversos, em benefício próprio ou alheio;
                    </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Realizará o tratamento de dados exclusivamente em Portugal ou noutro
                        país da União Europeia;
                    </li>
                    <li style={{ color: "#585858" }} className="pb-4 pl-4">
                        Disponibilizará ao UTILIZADOR as informações necessárias que
                        demonstrem o cumprimento das suas obrigações enquanto subcontratante no tratamento de dados pessoais.
                    </li>
                </ol>
                <br />
                <p style={{ color: "#585858" }} >
                    É da responsabilidade do UTILIZADOR informar os titulares dos dados, no
                    momento da sua recolha, sobre a finalidade dos tratamentos desses dados e da sua comunicação à Latourrette
                    Consulting, e, sendo necessário, obter o consentimento ao seu tratamento.
                </p>
                <p style={{ color: "#585858" }} >
                    A Latourrette Consulting obriga-se a prestar assistência ao UTILIZADOR,
                    na medida do possível, para permitir que este satisfaça os direitos dos titulares dos dados.
                </p>
                <p style={{ color: "#585858" }} >
                    Caso os titulares dos dados apresentem à Latourrette Consulting pedidos
                    de acesso, rectificação, oposição, eliminação ou portabilidade dos seus dados pessoais, a Latourrette Consulting
                    obriga-se a reencaminhar tais pedidos ao UTILIZADOR, o mais rapidamente possível, para o endereço de e-mail que
                    consta nos dados da conta de UTILIZADOR.
                </p>
                <p style={{ color: "#585858" }} >
                    A Latourrette Consulting obriga-se a não ceder os dados pessoais a que
                    tenha acesso a terceiros, nem sequer para efeitos da sua conservação, salvo a comunicação que, a cada momento,
                    seja necessária para que possam manter em segurança os sistemas (tanto do hardware como do software), e sempre
                    mediante a assinatura de um acordo que assegure que o terceiro cumpre com as suas obrigações enquanto
                    subcontratante.
                </p>
                <p style={{ color: "#585858" }} >
                    O UTILIZADOR deve ter em atenção que a Latourrette Consulting utiliza
                    fornecedores localizados nos Estados Unidos da América, pelo que os dados carregados através do SERVIÇO poderão
                    ser processados naquele país. A Latourrette Consulting ao contratar esses fornecedores para a realização de
                    operações específicas de tratamento de dados por conta do UTILIZADOR, impõe-lhes as mesmas obrigações em matéria
                    de proteção de dados que as estabelecidas na presente política de privacidade, em particular a obrigação de
                    apresentar garantias suficientes de execução de medidas técnicas e organizativas adequadas de uma forma que o
                    tratamento seja conforme os requisitos do RGPD.
                </p>
                <p style={{ color: "#585858" }} >
                    Em qualquer caso, sempre que a Latourrette Consulting pretenda
                    subcontratar terceiros, ou alterar os terceiros subcontratados, obriga-se a informar o CLIENTE desse facto. A
                    informação a prestar deve incluir a identificação do terceiro, os dados a comunicar ao terceiro e as medidas de
                    segurança adoptadas para garantir a segurança dos dados.
                </p>
                <p style={{ color: "#585858" }} >
                    A Latourrette Consulting obriga-se a comunicar ao UTILIZADOR, sem demora
                    injustificada após ter conhecimento, a verificação de uma violação dos dados pessoais.
                </p>
                <p style={{ color: "#585858" }} >
                    A referida comunicação deve ser acompanhada da documentação relevante
                    que permita ao UTILIZADOR, se necessário, notificar a autoridade de supervisão competente.
                </p>
                <p style={{ color: "#585858" }} >
                    O UTILIZADOR será responsável por notificar a autoridade de supervisão
                    competente caso se verifique uma quebra de segurança.
                </p>
                <p style={{ color: "#585858" }} >
                    A Latourrette Consulting obriga-se a guardar completo e total sigilo e
                    confidencialidade sobre os dados pessoais que tratar no contexto da prestação do SERVIÇO ao UTILIZADOR e a que
                    porventura tenha acesso durante a execução da prestação do SERVIÇO. A Latourrette Consulting compromete-se a não
                    divulgar, publicar, ou difundir a dita informação por qualquer meio, seja directamente ou através de terceiros,
                    sem o prévio consentimento escrito do UTILIZADOR.
                </p>
                <p style={{ color: "#585858" }} >
                    O UTILIZADOR obriga-se a respeitar o carácter confidencial dos métodos e
                    procedimentos utilizados pela Latourrette Consulting na prestação do SERVIÇO e assume responsabilidade pelo
                    cumprimento desta obrigação pelos seus colaboradores. O dever de confidencialidade não se aplicará à informação
                    que é acessível ao público em geral.
                </p>
                <p style={{ color: "#585858" }} >
                    No termo da prestação do SERVIÇO, a Latourrette Consulting compromete-se
                    a devolver ou destruir, conforme comunicado pelo UTILIZADOR, os dados pessoais que tenha na sua posse,
                    independentemente do formato em que se encontrem armazenados, excepto aqueles dados mínimos essenciais que devam
                    ser conservados para o cumprimento das suas obrigações legais.
                </p>
                <p style={{ color: "#585858" }} >
                    A Latourrette Consulting reserva-se o direito de, a qualquer momento,
                    alterar a presente política de privacidade, notificando para o efeito o UTILIZADOR com, pelo menos, 24 horas de
                    antecedência. Caso continue a utilizar o SERVIÇO após esse prazo, essas alterações serão consideradas aceites.
                    As presentes condições visam garantir ao utilizador um aproveitamento seguro e eficaz do serviço fornecido pela
                    Latourrette Consulting.
                </p>
                <p style={{ color: "#585858" }} >
                    Quaisquer dúvidas e questões relativas à presente política de
                    privacidade podem ser enviadas para <a href="mailto:support@bizdocs.mobi" style={{ color: "#6CB93D" }}>support@bizdocs.mobi.</a>
                </p>
            </div>
            <DesktopFooter />
            <MobileFooter bgColor="#6CB93D"/>
        </>
    );
};

export default function Bizdocs() {
    return (
        <Suspense fallback={<Loader />}>
            <BizdocsConst />
        </Suspense>
    );
}
